import AOS from 'aos';
import "aos/dist/aos.js";
import "../scss/page.scss";

import "../scss/aboutus.scss";
import "./scripts/slick/about-us.js";
// import "./scripts/about/hero.js";
import "./scripts/about/people.js";
import "./scripts/about/founder.js";
import "./scripts/about/shorts.js";
import "./scripts/matchHeight/about-us.js";
import "./scripts/calculatepadding.js";

AOS.init();